import React from 'react';
import Header from "../../header/Header";
import SliderMain from "../../slider-main/SliderMain";
import Filter from "../../filters/Filter";
import ApartmentContainerWrapper from "../../items-main-page/ApartmentContainerWrapper";
import ActionsArea from "../../action-aria-main/ActionsArea";
import About from "../../about/About";
import Footer from "../../footer/Footer";
import TestimonialsMultiPage from "../../items-main-page/TestimonialsMultiPage";


const MainPageComponent = () => {
    return(
        <>
            <Header/>
            <SliderMain/>
            <Filter/>
            <ApartmentContainerWrapper/>
            <ActionsArea/>
            <TestimonialsMultiPage/>
            <About/>
            <Footer/>
            {/*<div className="bg-light text-center text-lg-start">*/}
            {/*    <div className="container p-4">*/}
            {/*        <div className="row">*/}
            {/*            <div className="col-lg-6 col-md-12 mb-4 mb-md-0">*/}
            {/*                <h5 className="text-uppercase">Detection text tool from image</h5>*/}
            {/*                <p className="text-left p-3">*/}
            {/*                    Applications for parsing text from an image. Acceptable formats: jpg, png. Developed*/}
            {/*                    with: frontend (React), backend (Java 8, Spring Boot, Tesseract-OCR, openCV, Docker)*/}
            {/*                </p>*/}
            {/*            </div>*/}
            {/*            <div className="col-lg-6 col-md-12 mb-4 mb-md-0">*/}
            {/*                <h5 className="text-uppercase">Developer Dmitry Asmalouski</h5>*/}
            {/*                <p className="text-left p-3">*/}
            {/*                    <p>DEVELOPER WITH 3+ YEARS OF EXPERIENCE.</p>*/}
            {/*                    <p>	Programming language:  JAVA.</p>*/}
            {/*                    <p>	Technologies & Frameworks:  REST, JMS, Spring (Spring Framework, Spring Boot, Spring Security, Spring Cloud, Spring Data, Spring Admin, Spring Cloud Sleuth), Zipkin, Hibernate, Docker, Apache Tomcat, Multithreading, JDBC, JUnit, Maven, GraphQL, MapStruct.</p>*/}
            {/*                    <p>Clouding:   Heroku, Google cloud, AWS(S3).</p>*/}
            {/*                </p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="text-center p-3">*/}
            {/*        © 2021 Copyright:*/}
            {/*        <a className="text-dark" href="https://www.linkedin.com/in/dmitry-asmalouski-324b49a0/"> Dmitry*/}
            {/*            Asmalouski</a>*/}
            {/*    </div>*/}
            {/*</div>*/}
            </>
    )
};
export default MainPageComponent;